import { FetchError } from 'ofetch'
import * as Sentry from '@sentry/vue'

const useErrorHandler = () => {
  const DEFAULT_ERROR_MESSAGE = $t('common.errors.default')
  const { showSnackBanner } = useUIStore()
  const { logout } = useSuccessfulLogout()

  const captureException = (error: any) => {
    if (process.client) {
      Sentry.captureException(error)
    }
  }

  const isFetchError = (error: any) => {
    return error instanceof FetchError
  }

  const handleErrorResponse = (errorMessage: string, error: any, status: number | null) => {
    switch (status) {
      case 401:
        if (errorMessage !== 'Token is invalid or expired' && 
            errorMessage !== 'User not found') {
          showSnackBanner('error', errorMessage)
        }
        logout()
        break
      case 403:
        showSnackBanner('error', errorMessage)
        break
      case 500:
        captureException(error)
        showSnackBanner('error', DEFAULT_ERROR_MESSAGE)
        break
      case 404:
        if (errorMessage !== 'User not found') {
          captureException(error)
          showSnackBanner('error', errorMessage)
        }
        break
      default:
        captureException(error)
        showSnackBanner('error', errorMessage)
    }
  }

  const getErrorMessage = (error: any) => {
    if (isFetchError(error) && error.response?._data.message) {
      return error.response._data.message
    }

    if (isNuxtError(error)) {
      return error.message
    }

    return DEFAULT_ERROR_MESSAGE
  }

  const getErrorStatus = (error: any) => {
    if (isFetchError(error) && error.response?.status) {
      return error.response.status
    }

    if (isNuxtError(error)) {
      return error.statusCode
    }

    return null
  }

  const catchErrors = (error: any) => {
    // eslint-disable-next-line security-node/detect-crlf, no-console
    console.log(error)

    if (isFetchError(error) || isNuxtError(error)) {
      handleErrorResponse(getErrorMessage(error), error, getErrorStatus(error))
    } else {
      captureException(error)
      showSnackBanner('error', DEFAULT_ERROR_MESSAGE)
    }
  }

  return {
    catchErrors,
  }
}

export default useErrorHandler
